import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ArrUtil, deepClone, Dimension } from '@gspwidget/util';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { sysVars } from '../exp-editor/monaco-controller';

export interface EditableTableColumn {
  name: string
  title?: string
  template?: any
  placeholder?: string
  type?: 'text' | 'exp' | 'number'
  onClick?: () => void
}

@Component({
  selector: 'editable-table',
  templateUrl: './editable-table.component.html',
  styleUrls: ['./editable-table.component.scss']
})
export class EditableTableComponent implements OnInit {
  /** ç´æ¥ä¿®æ¹ data */
  @Input() data: any[] = []
  @Input() columns: EditableTableColumn[]
  /** TODO: è·ç»´åº¦è§£è¦ï¼ */
  @Input() rawDims: Dimension[] = []

  @ViewChild('expModalTmpl') expModalTmpl

  modalRef: BsModalRef
  // renderData
  JSON = JSON
  sysVars = sysVars
  curExpCol: EditableTableColumn
  curRowClone
  curRowIndex = -1

  constructor (
    // private cd: ChangeDetectorRef
    private modalSvc: BsModalService,
  ) { }

  ngOnInit () {
    // this.renderData = this.data
  }

  trackByFn (i, item) {
    return i + item
  }
  deleteRow (i: number) {
    this.data.splice(i, 1)
  }
  upRow (i: number) {
    ArrUtil.UpI(this.data, i)
  }
  downRow (i: number) {
    ArrUtil.DownI(this.data, i)
  }

  handleChangeNewRowValue (colName: string, i: number, value) {
    if (i === this.data.length) {
      if (!value) return
      (this.data as any[]).push({
        [colName]: value
      })
      // this.renderData = this.data.slice()
    }
  }

  handleClickExp (col: EditableTableColumn, i: number) {
    const invalidIndex = i > -1 && i < this.data.length
    // ææä¸æ ä¸ºç¼è¾ï¼å¦åä¸ºæ°å¢
    this.curRowClone = invalidIndex ? deepClone(this.data[i]) : {}
    this.curRowIndex = i
    this.curExpCol = col
    this.modalRef = this.modalSvc.show(this.expModalTmpl)
  }

  handleConfirmExp () {
    // ç¼è¾
    if (this.curRowIndex > -1 && this.curRowIndex < this.data.length) {
      this.data[this.curRowIndex] = this.curRowClone
    } else { // æ°å¢
      this.data.push(this.curRowClone)
    }
    this.modalRef.hide()
  }

}
